
interface CTASectionProps {
  onOpenQuoteModal: () => void;
  onOpenConsultationModal: () => void;
}

export default function CTASection({ onOpenQuoteModal, onOpenConsultationModal }: CTASectionProps) {
  return (
    <section id="contact" className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-32 h-32 border border-white rounded-full"></div>
        <div className="absolute bottom-20 right-20 w-24 h-24 border border-white rounded-full"></div>
        <div className="absolute top-1/2 left-1/3 w-16 h-16 border border-white rounded-full"></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Prêt à transformer votre cabinet ?
          </h2>
          <p className="text-xl md:text-2xl mb-12 opacity-90">
            Rejoignez les 10+ cabinets comptables français qui ont choisi EMA 
            pour optimiser leur activité et booster leur rentabilité.
          </p>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="text-center">
              <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-2xl text-black"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Appelez-nous</h3>
              <p className="opacity-80">+33 6 15 46 78 15</p>
              <p className="opacity-80">+216 29 50 70 50</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-2xl text-black"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Écrivez-nous</h3>
              <p className="opacity-80">contact@scmggroup.com</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-line text-2xl text-black"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Planifiez</h3>
              <p className="opacity-80">Un entretien gratuit</p>
              <p className="opacity-80">sous 24h</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={onOpenConsultationModal}
              className="bg-gray-200 text-black px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Planifier un entretien gratuit
            </button>
            <button 
              onClick={onOpenQuoteModal}
              className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-black transition-colors whitespace-nowrap cursor-pointer"
            >
              Demander un devis gratuit
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
